import styled from 'styled-components';

export const BookingsWithMinorsSearchHeader = styled.div`
  @media (min-width: 700px) {
    display: flex;
    margin-left: 16px;

    > * {
      flex: 1;
    }
  }
`;
